/*
 * @Descripttion: 公用配置项
 * @Author: shenah
 * @Date: 2023-08-10 15:02:19
 * @LastEditors: shenah
 * @LastEditTime: 2023-08-14 09:35:47
 */

// 字体列表选择
export const fontList = [
  {
    text: "微软雅黑",
    value: "Microsoft Yahei",
  },
];

// 值的转化列表
export const unitValueMap = {
  10: "十",
  100: "百",
  1000: "千",
  10000: "万",
  100000: "十万",
  1000000: "百万",
  10000000: "千万",
  100000000: "亿",
};
